import { ProvidersShell } from './ProvidersShell';
import { SpendHistoryPanel } from './SpendHistoryPanel';

/** /dev-console/providers/spend — per-provider spend + volume over time. */
export function ProviderSpendPage() {
  return (
    <ProvidersShell>
      <SpendHistoryPanel />
    </ProvidersShell>
  );
}
